export const USE_ANALYTICS_KEY = 'USE_ANALYTICS';
